import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter } from '@soundxyz/font-awesome/free-brands-svg-icons/index.mjs';
import { faCheck } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { faCopy } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { theme } from '@components-shared/src/stitches';
import { Input } from '@components/basics/forms/inputs/Input';
import { Button } from '@components/main-components/button/Button';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';
import { useCopy } from '@hooks/useCopy';
import type { TopChartsType } from '@pages-shared/topCharts';
import { getUrlPathForTwitter } from '@utils/helpers';

export const SmallShare = ({
  url,
  type,
  subType,
}: {
  url: string;
  type: 'drop' | 'playlist' | 'viral' | 'top';
  subType?: TopChartsType;
}) => {
  const { copy, isCopied } = useCopy({
    text: url,
    successMessage: 'Link copied to clipboard',
  });

  const onTwitterShareClick = () => {
    const path = getUrlPathForTwitter({ type, url, subType });
    window.open(path, '_newtab');
  };

  return (
    <>
      <div
        className="mb-4 flex items-center justify-center overflow-hidden rounded-md border border-neutral100"
        onClick={copy}
      >
        <Input
          disabled
          value={url}
          className="h-11 w-full truncate rounded-none disabled:bg-transparent disabled:text-black"
        />
        <IconButton
          variant="tertiary"
          className="h-11 w-10 shrink-0 rounded-none !bg-base50 duration-200"
          iconSize={16}
          size={24}
          icon={
            isCopied ? (
              <FontAwesomeIcon icon={faCheck} color={theme.colors.brand600.toString()} />
            ) : (
              <FontAwesomeIcon icon={faCopy} />
            )
          }
        />
      </div>
      <Button
        variant="tertiary"
        label="Share to Twitter"
        leadingIcon={<FontAwesomeIcon icon={faTwitter} />}
        onClick={onTwitterShareClick}
        size="M"
        fullWidth
      />
    </>
  );
};
